import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.68506 7.50852L12.9617 13.4461L23.2383 7.50852M4.15314 3.05533H21.7702C22.581 3.05533 23.2383 3.71992 23.2383 4.53973V19.3837C23.2383 20.2035 22.581 20.8681 21.7702 20.8681H4.15314C3.34234 20.8681 2.68506 20.2035 2.68506 19.3837V4.53973C2.68506 3.71992 3.34234 3.05533 4.15314 3.05533Z",
  stroke: "currentColor",
  "stroke-width": "1.37021"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MailIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "mail",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})